export type ApplicationStage = "draft" | "submitted" | "under_review" | "changes_requested" | "approved" | "denied";

export const STAGE_LABELS: Record<ApplicationStage, string> = {
  draft: "Draft",
  submitted: "Submitted",
  under_review: "Under Review",
  changes_requested: "Changes Requested",
  approved: "Approved",
  denied: "Denied"
};

export type ApplicationType = "affiliate" | "associate" | "member";

export type ApplicationTab = "all" | "affiliate" | "associate" | "member" | "reciprocity";

export type ApplicationRequirementMetricId =
  | "pat"
  | "pgm_associate"
  | "background_check"
  | "experience_credits"
  | "dues";

/** Automatically verified prerequisite cards shown per application type on the overview page. */
export const APPLICATION_REQUIREMENT_METRICS_BY_TYPE: Record<ApplicationType, ApplicationRequirementMetricId[]> = {
  affiliate: ["pgm_associate", "background_check"],
  associate: ["pat", "pgm_associate", "background_check", "dues"],
  member: ["pat", "pgm_associate", "background_check", "experience_credits", "dues"]
};

export const APPLICATION_TYPE_LABELS: Record<ApplicationType, string> = {
  affiliate: "Affiliate",
  associate: "Associate",
  member: "Member"
};

export const UNASSIGNED_REVIEWER_LABEL = "Unassigned";

export type ApplicationDeniedReason =
  | "ineligible_employment"
  | "ineligible_education_document"
  | "missing_documentation"
  | "prerequisites_incomplete"
  | "incorrect_beneficiary"
  | "missing_graduation_information";

export const DENIED_REASON_LABELS: Record<ApplicationDeniedReason, string> = {
  ineligible_employment: "Ineligible Employment",
  ineligible_education_document: "Ineligible Education Document",
  missing_documentation: "Missing Documentation",
  prerequisites_incomplete: "Pre-requisite(s) Incomplete",
  incorrect_beneficiary: "Incorrect Beneficiary",
  missing_graduation_information: "Missing Graduation Information"
};

export const DENIED_REASON_OPTIONS: { value: ApplicationDeniedReason; label: string }[] = (
  Object.keys(DENIED_REASON_LABELS) as ApplicationDeniedReason[]
).map((value) => ({ value, label: DENIED_REASON_LABELS[value] }));
